import { agentReportsUrl } from '../actions/statistics';


export function getDownloadAgentReportCsvURL(data) {
    return `${SERVICE_URL}${agentReportsUrl}/exporttocsv?startDate=${data.startDate}&endDate=${data.endDate}`;
}
